/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApplicationUserFromJSON, ApplicationUserToJSON, DamageDictionaryValueFromJSON, DamageDictionaryValueToJSON, DamageKindDictionaryValueFromJSON, DamageKindDictionaryValueToJSON, } from './';
export function ProtocolDamageDetailFromJSON(json) {
    return ProtocolDamageDetailFromJSONTyped(json, false);
}
export function ProtocolDamageDetailFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : ApplicationUserFromJSON(json['createdBy']),
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : ApplicationUserFromJSON(json['modifiedBy']),
        'modifiedById': !exists(json, 'modifiedById') ? undefined : json['modifiedById'],
        'damageDictionary': !exists(json, 'damageDictionary') ? undefined : DamageDictionaryValueFromJSON(json['damageDictionary']),
        'damageDictionaryId': !exists(json, 'damageDictionaryId') ? undefined : json['damageDictionaryId'],
        'damageKinds': !exists(json, 'damageKinds') ? undefined : (json['damageKinds'] === null ? null : json['damageKinds'].map(DamageKindDictionaryValueFromJSON)),
        'note': !exists(json, 'note') ? undefined : json['note'],
        'filesDocumentation': !exists(json, 'filesDocumentation') ? undefined : json['filesDocumentation'],
        'protocolId': !exists(json, 'protocolId') ? undefined : json['protocolId'],
    };
}
export function ProtocolDamageDetailToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdBy': ApplicationUserToJSON(value.createdBy),
        'modifiedBy': ApplicationUserToJSON(value.modifiedBy),
        'damageDictionary': DamageDictionaryValueToJSON(value.damageDictionary),
        'damageDictionaryId': value.damageDictionaryId,
        'damageKinds': value.damageKinds === undefined ? undefined : (value.damageKinds === null ? null : value.damageKinds.map(DamageKindDictionaryValueToJSON)),
        'note': value.note,
        'filesDocumentation': value.filesDocumentation,
        'protocolId': value.protocolId,
    };
}
